import { useMemo } from 'react'

import { useAreaListado } from '../../areas/api/apiAreaListado.ts'
import { MODO_SALIDA } from '../../restaurante/interfaces/comanda.ts'

/**
 * Áreas de la sucursal que trabajan con pantalla de cocina (modo PANTALLA o AMBOS), por orden.
 * Solo estas tienen estado de cocina: las de modo IMPRESION, las impresoras usadas como área
 * y GENERAL siempre llegan con estado null, así que no hace falta consultarlas.
 * @param codigoSucursal Sucursal de la sesión (0 es válido: casa matriz).
 * @param enabled false para no consultar (ej. sin sucursal en la sesión).
 */
export const useAreasPantalla = (codigoSucursal: number, enabled = true) => {
  const { data, isLoading, error } = useAreaListado({ codigoSucursal }, { enabled, staleTime: 5 * 60_000 })
  const areas = useMemo(
    () =>
      (data ?? [])
        .filter((a) => a.modoSalida !== MODO_SALIDA.IMPRESION)
        .sort((a, b) => (a.orden ?? 0) - (b.orden ?? 0)),
    [data],
  )
  /** _id de las áreas con pantalla (referencia estable mientras no cambie el listado) */
  const ids = useMemo(() => areas.map((a) => a._id), [areas])

  return { areas, ids, isLoading, error }
}
